<div id="layout" class="f_col">
    <app-view-title bgImage="assets-countries/header_background.png">{{'security.loader' | translate}}</app-view-title>
    <div class="scroll_wrapper">
      <app-view-deco-image maxWidth="300px" imageUrl="assets/images/security.svg"></app-view-deco-image>
      <app-paragraph>{{'security.false' | translate}}</app-paragraph>
      <app-paragraph class="mt_10">{{'security.root' | translate}}</app-paragraph>
    </div>
</div>
  